import http from '../utils/HttpCommon';

const obterUrlAcessoGovBr = () => {
  return http.get('/acesso-stn/gerar-url-acesso-gov-br');
};

export default {
  obterUrlAcessoGovBr
};
